import React from 'react';
import { Moment } from 'moment-timezone';
import { momentForDomain } from '@common/services/moment-shadow';
import { DatePicker, FormInstance } from 'antd';
import { Form, Col } from '@common/components';
import { TimeInput } from './time-input';
import { OrganizationUnitShiftConfigFlatType } from '@scheduling/graphql';

const moment = momentForDomain('scheduling', 'shifts');

export function StartDatetimeSelect({
  disabled = false,
  loading = false,
  form,
  shiftConfigs,
  onTimeSelect,
  startTime,
}: {
  form: FormInstance;
  shiftConfigs: OrganizationUnitShiftConfigFlatType[];
  onTimeSelect: (value?: string) => void;
  startTime?: string;
  disabled?: boolean;
  loading?: boolean;
}) {
  const shiftStartDisabledDate = (currentDate: Moment) => {
    return moment(currentDate).startOf('day').isBefore(moment().startOf('day'));
  };

  return (
    <>
      <Col span={12}>
        <Form.Item
          label="Start Date"
          name="startDate"
          rules={[{ required: true, message: 'Please enter a start date' }]}
        >
          <DatePicker
            data-testid="shift-start-date"
            autoComplete="off"
            name="startDate"
            size="large"
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
            showToday={false}
            disabled={disabled}
            disabledDate={shiftStartDisabledDate}
            onChange={(value) => (value ? value.utc(true) : value)}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={12} className="StartDatetimeSelect">
        <Form.Item
          label="Start Time"
          name="startTime"
          rules={[{ required: true, message: 'Please enter a start time' }]}
        >
          <TimeInput
            disabled={disabled || loading}
            shiftConfigs={shiftConfigs}
            onTimeSelect={onTimeSelect}
            startTime={startTime}
            form={form}
          />
        </Form.Item>
      </Col>
      <style jsx>
        {`
          :global(.CreateShiftForm .ant-input-number),
          :global(.StartDatetimeSelect .ant-picker) {
            width: 100%;
          }
        `}
      </style>
    </>
  );
}
